export enum GetDataStatusEnum {
  NONE = 'None',
  PENDING = 'Pending',
  SUCCESS = 'Success',
  FAIL = 'Fail',
}
